/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { Suspense, useEffect, useRef, useState } from 'react'
import View from '../atoms/View'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_CONVERSATION, FETCH_OFFER } from 'dealer-reducers'
import VehicleImage from '../molecules/offer/VehicleImage'
import VehicleTitle from '../molecules/offer/VehicleTitle'
import VehicleImages from '../molecules/offer/VehicleImages'
import Conversation from '../molecules/offer/Conversation'
import { RootReducer } from '../../redux/rootReducer'
import Space from '../atoms/Space'
import { useNumberParams } from 'src/hooks/useNumberParams'
import 'photoswipe/dist/photoswipe.css'
import { Gallery } from 'react-photoswipe-gallery'
import Layout from '../layout/Layout'
import { useTranslation } from 'react-i18next'
import SearchSvg from '../other/svg/SearchSvg'
import getVehicleComponent from 'src/helpers/getVehicleComponent'
import Spinner from '../atoms/Spinner'
import track from 'src/helpers/track'
import OfferTopSection from '../molecules/OfferTopSection'
interface Props {
  offerId?: number
}

const Offer = ({ offerId }: Props): JSX.Element => {
  const paramsID = useNumberParams('id')
  const id = offerId ?? paramsID
  const { t } = useTranslation()
  const dispatch = useDispatch()

  useEffect(() => {
    track('dealer_open_offer')
  }, [])

  useEffect(() => {
    dispatch(FETCH_OFFER({ id }))
  }, [dispatch, id])

  const offer = useSelector((state: RootReducer) => state.offerReducer[id])
  const offerHashId = offer?.hash_id
  const vehicleLoaded = typeof offer !== 'undefined'
  const VehicleComponent = getVehicleComponent(offer?.vehicle_type, vehicleLoaded)

  useEffect(() => {
    if (offerHashId?.length > 0) {
      dispatch(FETCH_CONVERSATION({ offer_hash_id: offerHashId }))
    }
  }, [offerHashId, dispatch])

  return (
    <Layout
      withoutToolbar={false}
      iconComponent={<SearchSvg className="w-8 text-white" />}
      withFiler={false}
      name={t('all_vehicles')}>
      {vehicleLoaded ? (
        <Gallery
          options={{
            mouseMovePan: true
          }}
          uiElements={[
            {
              name: 'zoom-out-button',
              order: 8,
              onInit: (element, pswp) => {
                element.innerHTML = `
                  <button style="background-color: black; border-radius: 10px; margin: 5px; display: flex; width: 130px; height: 40px; margin-top: 15px;" class="flex items-center justify-center mx-2 mt-2 pswp__button pswp__button--zoom-out" title="Zoom Out">
                    <span style="font-size: 18px; font-weight: bold; color: white;">−</span>
                    <span style="font-size: 12px; margin-left: 4px; color: white;">Zoom Out</span>
                  </button>
                `
                element.onclick = () => {
                  const currentZoom = pswp.currSlide?.currZoomLevel ?? 1
                  pswp.zoomTo(Math.max(0.1, currentZoom - 0.1))
                }
              }
            },
            {
              name: 'zoom-in-button',
              order: 9,
              onInit: (element, pswp) => {
                element.innerHTML = `
                  <button style="background-color: black; border-radius: 10px; margin: 5px; display: flex; width: 130px; height: 40px; margin-top: 15px;" class="flex items-center justify-center mx-2 mt-2 pswp__button pswp__button--zoom-in" title="Zoom In">
                    <span style="font-size: 18px; font-weight: bold; color: white;">+</span>
                    <span style="font-size: 12px; margin-left: 4px; color: white;">Zoom In</span>
                  </button>
                `
                element.onclick = () => {
                  const currentZoom = pswp.currSlide?.currZoomLevel ?? 1
                  pswp.zoomTo(currentZoom + 0.1)
                }
              }
            }
          ]}>
          <OfferTopSection offer={offer} />
          <Space y={5} />
          <Suspense fallback={<>waiting</>}>
            <VehicleComponent />
          </Suspense>
          <View className="h-[100px] block 2xl:hidden">
            <Conversation offerHashId={offerHashId} />
          </View>
        </Gallery>
      ) : (
        <Spinner />
      )}
    </Layout>
  )
}

export default Offer
